import axios from "axios";
//@ts-ignore cortex
import { trans } from "@cortexglobal/rla-intl";
//@ts-ignore cortex
import { useAddToast, useToasts } from "@cortexglobal/rla-components";

import { Link } from "../forms/LinkForm";
const useLinks = () => {
    const addToast = useAddToast();
    const [_, dispatch] = useToasts();

    const loadToast = (message) => {
        addToast({
            uuid: "loadToast",
            type: "loader",
            content: message,
        });
    };

    const removeLoadToast = () => {
        dispatch({ type: "removeToast", uuid: "loadToast" });
    };

    const loadItems = (
        setItems,
        page,
        search,
        orderBy,
        orderByDir,
        perPage
    ): Promise<Link[]> => {
        setItems({
            loaded: false,
        });
        return axios
            .get(`/api/v1/admin/link`, {
                params: {
                    page: page,
                    search: search ? search : null,
                    sortDirection: orderByDir ? orderByDir : null,
                    sortField: orderBy ? orderBy : null,
                    perPage: perPage ? perPage : 10,
                },
            })
            .then(({ data }) => {
                setItems({
                    loaded: true,
                    data: data.data,
                    pagination: data.meta,
                });
                return data;
            });
    };
    const deleteItem = (
        uuid,
        setItems,
        page = "1",
        search,
        orderBy,
        orderByDirection,
        perPage
    ): Promise<Link[]> => {
        loadToast(trans("Deleting link"));
        return axios
            .delete(`/api/v1/admin/link/${uuid}`)
            .then(({ data }) => {
                removeLoadToast();
                return loadItems(
                    setItems,
                    page,
                    search,
                    orderBy,
                    orderByDirection,
                    perPage
                ).then((data) => {
                    return data;
                });
            })
            .catch((e) => {
                removeLoadToast();

                if (e.response.data && e.response.data.message) {
                    addToast({
                        type: "alert",
                        content: e.response.data.message,
                        showFor: 5000,
                    });
                } else {
                    addToast({
                        type: "alert",
                        content: trans("An error occurred deleting the link"),
                        showFor: 5000,
                    });
                }
                throw e;
            });
    };

    return {
        loadItems,
        deleteItem,
    };
};

export default useLinks;
